// extracted by mini-css-extract-plugin
export default {"outerContainer":"CuepointText_outerContainer__efndC","innerContainer":"CuepointText_innerContainer__GrpHZ","textContainer":"CuepointText_textContainer__Pd7GF"};